import Onboarding from 'components/onboarding';

const OnboardingPage = () => {
  return <Onboarding />;
};

export default OnboardingPage;
